import {conversion,countDownS} from "@/tool";
import Picture from '@/components/picture';
export default {
	filters: {
		conversion,
		countDownS
	},
	components:{
		'c-picture': Picture,
	},
	props: {
		/** 饰品类型 */
		awardType:{
			type:String
		},
		/** 限时饰品 */
		present:{
			type:Boolean
		},

		/** 锁定饰品 */
		LockType:{
			type:Number
		},
		/** 是否缺货 */
		shortage:{
			type:Boolean
		},

		/** 是否取回 */
		redeeming:{
			type:Boolean
		},

		/** 仅能取回 */
		fromExchange:{
			type:Boolean
		},

		/** 取回时间 */
		timeExpire:{
			type:String
		},

		/** 背景色透明度 */
		background_opacity: {
			type: [Number, String],
			default: .6
		},


		/** 奖品品级 */
		rarity: {
			type: Number
		},

		/** 奖品概率 */
		rate: {
			type: Number
		},

		/** 奖品图片 */
		picture: {
			type: String
		},

		/** 奖品名称 */
		name: {
			type: String
		},

		/** 奖品描述 */
		descriptor: {
			type: String
		},

		/** 奖品价格 */
		price: {
			type: Number
		},

		/** 是否图片有品级背景 */
		has_picuter_rarity: {
			type: Boolean,
			default: false
		},

		/** 是否有底部品级栏 */
		has_bottom_rarity_bar: {
			type: Boolean,
			default: false
		},

		/** 是否有阴影 */
		has_shadow: {
			type: Boolean,
			default: false
		},

		/** 是否有交互动画 */
		has_interactive: {
			type: Boolean,
			default: false
		},

		/** 是否已选择 */
		is_checked: {
			type: Boolean,
			default: false
		}
	}
};
